import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import EnTitle, { splitEn } from './EnTitle';
import FlowLines from './FlowLines';

// Sub-page hero: charcoal band with the big English section name
// ("OUR / PRODUCTS"), the localized page title under it, and the breadcrumb
// trail on white beneath — mirrors the corporate site's "lower-hero".
//   en       – English section name for the big headline; falls back to title
//   title    – localized page/item title shown under the headline
export default function PageBanner({ en, title, subtitle, breadcrumbs = [] }) {
  const { t } = useLanguage();
  return (
    <>
      <div className="relative bg-charcoal text-white overflow-hidden h-[220px] sm:h-[260px] lg:h-[300px]">
        <FlowLines />
        <div className="relative h-full w-[90%] mx-auto flex flex-col justify-end pb-7">
          <EnTitle as="h1" lines={splitEn(en || title)} light className="text-[2.6rem] sm:text-6xl lg:text-7xl" />
          {title && <p className="mt-3 font-bold text-base sm:text-lg line-clamp-2">{title}</p>}
          {subtitle && <p className="mt-1 text-sm text-gray-300 max-w-xl">{subtitle}</p>}
        </div>
      </div>

      {breadcrumbs.length > 0 && (
        <nav aria-label="Breadcrumb" className="w-[90%] mx-auto py-5">
          <ol className="flex flex-wrap items-center gap-y-1 text-xs sm:text-sm text-gray-400">
            <li><Link to="/" className="text-primary font-semibold hover:opacity-70 transition-opacity">{t('common.home').toUpperCase()}</Link></li>
            {breadcrumbs.map((b, i) => (
              <li key={i} className="flex items-center min-w-0">
                <span className="w-px h-3.5 bg-gray-300 mx-4" aria-hidden="true" />
                {b.to ? (
                  <Link to={b.to} className="text-primary font-semibold hover:opacity-70 transition-opacity">{b.label}</Link>
                ) : (
                  <span aria-current="page" className="truncate max-w-[60vw]">{b.label}</span>
                )}
              </li>
            ))}
          </ol>
        </nav>
      )}
    </>
  );
}
